import React from 'react';
import './modals-bootstrap.css';

const ModalsBootstrap = ({ okayButtonText, cancelButtonText, bodyText, headerText, onClick }) => (
  <div className="modal fade" id="modalCenter" tabIndex="-1" role="dialog"
       aria-labelledby="modalCenterTitle" aria-hidden="true">
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h2 id="exampleModalLongTitle">{headerText}</h2>
        </div>
        <div className="modal-body">
          {bodyText}
        </div>
        <div className="modal-footer justify-content-center">
          {cancelButtonText && okayButtonText &&
          <div>
            <button type="button" className="btn btn-secondary" data-dismiss="modal">{cancelButtonText}</button>
            <button type="button" className="btn btn-primary" onClick={onClick}>{okayButtonText}</button>
          </div>
          }
          {!cancelButtonText && okayButtonText &&
          <div>
            <button type="button" className="btn btn-primary" onClick={onClick}>{okayButtonText}</button>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
);

export default ModalsBootstrap;


// WEBPACK FOOTER //
// ./src/ui-elements/modals-bootstrap/modals-bootstrap.js